import React from "react";
import { List, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Menu } from "lucide-react";
import { IconButton } from "@mui/material";
import { notifyError } from "../utils/Toastify";

const SideMenu = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const handleComingSoon = () => {
    notifyError("Coming Soon!");
  };

  const menuItems = [
    {
      label: "All MicroAgent Apps",
      path: `https://app.microagent.services/autologin?token=${token}&source_app=CHATBOT&target_app=APP`,
      available: true,
    },
    {
      label: "MicroAgent CRM",
      path: `https://crm.microagent.services/autologin/?token=${token}&source_app=CHATBOT&target_app=CRM`,
      available: true,
    },
    {
      label: "MicroAgent Chatbot",
      path: `https://chatbot.microagent.services/autologin/?token=${token}&source_app=CHATBOT&target_app=CHATBOT`,
      available: true,
      current: true,
    },
    {
      label: "MicroAgent Communication",
      path: `https://message.microagent.services/autologin?token=${token}&source_app=CHATBOT&target_app=COMMUNICATION`,
      available: true,
    },
    {
      label: "MicroAgent Voice Facilitator",
      path: `https://message.microagent.services/autologin?token=${token}&source_app=CHATBOT&target_app=VOICE`,
      available: true,
    },
    {
      label: "MicroAgent LMS",
      path: "/dashboard/lms",
      available: false,
    },
    {
      label: "Performance Tracker",
      path: "/dashboard/performance",
      available: false,
    },
    {
      label: "MicroAgent Quiz App",
      path: "/dashboard/quiz",
      available: false,
    },
  ];

  return (
    <div>
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-700">
        <h2 className="text-lg font-bold">MicroAgents</h2>
        <IconButton
          className="!text-[#64748b] hover:text-gray-300"
          size="large"
        >
          <Menu />
        </IconButton>
      </div>

      <List>
        {menuItems.map((item) => (
          <ListItemButton
            key={item.label}
            onClick={() => {
              if (item.available) {
                // Navigate to available apps
                window.location.href = item.path;
              } else {
                // Show coming soon for unavailable apps
                handleComingSoon();
              }
            }}
            sx={{
              color: "#64748b",
              "&:hover": { backgroundColor: "#1e293b", color: "#fff" },
              cursor: "pointer",
              opacity: item.available ? 1 : 0.5, // Dim unavailable items
            }}
          >
            <ListItemText
              primary={item.label}
              secondary={!item.available ? "Coming Soon" : undefined}
              primaryTypographyProps={{
                fontSize: "15px",
                fontWeight: 500,
                marginBottom: "0.3rem",
              }}
              secondaryTypographyProps={{
                fontSize: "11px",
                color: "#64748b",
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </div>
  );
};

export default SideMenu;
